export const SET_CORPORATIONS = "SET_CORPORATIONS"
export const SET_CURRENT_CORPORATION = "SET_CURRENT_CORPORATION"
